import React from "react";
import { Link } from "react-router-dom";
import { useSettings, resolveImage } from "../lib/settings";
import { Film, ArrowRight } from "lucide-react";

const DiziTours = () => {
  const { settings } = useSettings();
  const s = settings || {};

  if (s.show_dizi_tours === false) return null;

  const images = s.dizi_tours_images || [];

  return (
    <section className="section bg-[var(--ri-cream)]">
      <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="eyebrow mb-3 inline-flex items-center gap-2">
            <Film size={14} /> {s.dizi_tours_eyebrow || "As seen on screen"}
          </p>
          <h2 className="font-serif-display text-[34px] md:text-[44px] leading-[1.08] max-w-[480px]">
            {s.dizi_tours_title || "Turkish Dizi Tours"}
          </h2>
          <p className="mt-5 text-[16px] leading-[1.75] text-[var(--ri-ink-soft)] max-w-[480px]">
            {s.dizi_tours_text}
          </p>
          <Link to="/dizi-tour-request" className="btn-primary inline-flex items-center gap-2 mt-7">
            {s.dizi_tours_cta_label || "Plan your Dizi tour"} <ArrowRight size={16} />
          </Link>
        </div>

        {images.length > 0 && (
          <div className="grid grid-cols-2 gap-3">
            {images.map((img, i) => (
              <div
                key={i}
                className={`relative rounded-2xl overflow-hidden ${
                  i === 0 ? "col-span-2 aspect-[16/9]" : "aspect-square"
                }`}
              >
                <img
                  src={resolveImage(img.image)}
                  alt={img.caption || "Turkish Dizi filming location"}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                {img.caption && (
                  <span className="absolute bottom-2 left-2 right-2 text-[11px] text-white/95 bg-black/35 backdrop-blur-sm px-2.5 py-1 rounded-md">
                    {img.caption}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default DiziTours;
